import { ApplicantStateful } from './applicant-stateful.class';

export type CreditType = 'individual' | 'joint';

export class Applicant {
  public readonly iteration?: number;
  public readonly isCoBorrowerAJointApplication: boolean;
  public readonly entityId: string;
  public readonly parentId?: string;
  public readonly isPrimaryApplicant: boolean;
  public creditType: CreditType;

  public get borrowerId(): string {
    return <string>this.state.borrowerId.value;
  }
  public get firstName(): string {
    return <string>this.state.firstName.value;
  }
  public get lastName(): string {
    return <string>this.state.lastName.value;
  }

  public static areSame(applicant1: Applicant, applicant2: Applicant): boolean {
    if (!applicant1 || !applicant2) {
      return false;
    }

    return applicant1 === applicant2 || applicant1.entityId === applicant2.entityId;
  }

  public get displayName(): string {
    const prefix = this.isPrimaryApplicant ? 'Primary Applicant' : `CoApplicant(${this.index + 1})`;
    if (this.firstName || this.lastName) {
      return `${prefix} - ${this.firstName} ${this.lastName}`;
    }
    return prefix;
  }

  public get hasParent(): boolean {
    return !!this.parentId;
  }

  /**
   * Main applicants will have credit report pulled on them. Can be joint or individual.
   */
  public get isMainApplicant(): boolean {
    return !this.hasParent && !this.isPrimaryApplicant;
  }

  public get coBorrowerIndex(): number {
    return this.index;
  }

  constructor(private readonly state: ApplicantStateful, private readonly index: number) {
    this.iteration = state.iteration;
    this.entityId = <string>state.entityId.value;
    this.isCoBorrowerAJointApplication = <boolean>state.isCoBorrowerAJointApplication.value;
    this.isPrimaryApplicant = state.isPrimaryApplicant;
    this.parentId = <string>state.parentId.value;
  }

  public setParent(parent: Applicant): void {
    if (!this.isPrimaryApplicant) {
      this.state.parentId.value = parent.entityId;
      this.state.isCoBorrowerAJointApplication.value = true;
      this.state.isCoApplicantHasJoint.value = true;
    }
  }

  public setChild(): void {
    this.state.isCoApplicantHasJoint.value = true;
  }

  public removeParent(): void {
    if (this.state.parentId.value) {
      this.state.parentId.value = null;
      this.state.isCoBorrowerAJointApplication.value = false;
      this.state.isCoApplicantHasJoint.value = false;
    }
  }
}
